import React, { useEffect, useState } from 'react';
import {ListGroup, Row, Col} from 'react-bootstrap';

export default function SearchResults({programs, selectProgram, searchtext}) {

 const [results, setResults] = useState([])

  useEffect(() => {
    if (programs) {
      //do filter
      setResults(programs.filter(q => q.name.indexOf(searchtext) > -1))      
    }

  }, [searchtext, programs])


  return (
    <div className="searchResultsPopper">
      <ListGroup variant="flush">
        {results.map((item, index) => (
          <ListGroup.Item key={index} onClick={() => selectProgram(item)}>
            <Row>
              <Col>{item.name}</Col>
              <Col>{item.type}</Col>
              <Col>{item.id}</Col>
            </Row>
          </ListGroup.Item>
        ))}
      </ListGroup>     
    </div>
  )
}